import React from "react";
import Topbar from "../Topbar";
import ImgHeader from "./ImgHeader";
import Banner1 from "./Banner1";
import Images from "./Images";
import Section5 from "./Section5";
import BannerImg from "../BannerImg";
import Footer from "../Footer";
import { Container } from "react-bootstrap";
import BG from "../../assets/Images/BG.jpg";
import SEO from "../SEO";

export default function Blog1() {
  // Structured data for Blog1 - Victorian Colonial home design
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: "Designing a Victorian Colonial Home",
    description:
      "A Victorian Colonial home blends the grandeur of Victorian-era design with the symmetry and practicality of Colonial architecture. This style is known for its ornate details, rich materials, and classic elegance, making it a timeless choice for interiors.",
    url: "https://kritikagoswamymalik.com/blog1",
    datePublished: "2024-12-26T10:00:00+00:00",
    dateModified: "2024-12-26T10:00:00+00:00",
    author: {
      "@type": "Person",
      name: "Kritika Goswamy Malik",
      jobTitle: "Interior Designer",
      url: "https://kritikagoswamymalik.com/about",
    },
    publisher: {
      "@type": "Organization",
      name: "KGM Interiors",
      url: "https://kritikagoswamymalik.com/",
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": "https://kritikagoswamymalik.com/blog1",
    },
    articleSection: "Interior Design",
    keywords: [
      "Victorian Colonial home",
      "Victorian era design",
      "Colonial architecture",
      "ornate details",
      "rich materials",
      "classic elegance",
      "timeless interiors",
    ],
    about: {
      "@type": "Thing",
      name: "Victorian Colonial Interior Design",
      description:
        "Interior design style that combines Victorian grandeur with Colonial symmetry and practicality",
    },
  };

  return (
    <>
      <SEO
        title="Designing a Victorian Colonial Home"
        description="A Victorian Colonial home blends the grandeur of Victorian-era design with the symmetry and practicality of Colonial architecture. This style is known for its ornate details, rich materials, and classic elegance, making it a timeless choice for interiors."
        keywords="victorian colonial home, victorian era design, colonial architecture, ornate details, rich materials, classic elegance, timeless interiors, interior design blog"
        canonicalUrl="/blog1"
        article={true}
        publishedDate="2024-12-26T10:00:00+00:00"
        modifiedDate="2024-12-26T10:00:00+00:00"
        structuredData={structuredData}
      />

      <Container
        fluid
        className="p-0"
        style={{
          backgroundColor: "#F5F5DC",
          backgroundImage: `url(${BG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Topbar />
        <ImgHeader />
        <Banner1 />
        <Images />
        <Section5 />
        <BannerImg />
        <Footer />
      </Container>
    </>
  );
}
